import { render, staticRenderFns } from "./EndRequest.vue?vue&type=template&id=40a0f62a"
import script from "./EndRequest.vue?vue&type=script&lang=ts"
export * from "./EndRequest.vue?vue&type=script&lang=ts"
import style0 from "./EndRequest.vue?vue&type=style&index=0&id=40a0f62a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports